import httpClientWrapper from '@/helpers/HttpClientWrapper'
import jwtHelper from '@/helpers/JwtHelper'
import Gift from '@/model/Gift'
import Borrowing from '@/model/Borrowing'
import Exchange from '@/model/Exchange'
import OperationApproval from '@/model/OperationApproval'
import Operation from '@/model/Operation'
import OperationFilter from '@/model/OperationFilter'
import userService from '@/service/UserService'
import { operationStatusEnum } from '@/helpers/Constants'

const operationService = {
    createGift: createGift,
    createBorrowing: createBorrowing,
    createExchange: createExchange,
    approve: approve,
    confirm: confirm,
    cancel: cancel,
    confirmRetrieval: confirmRetrieval,
    getChatThread: getChatThread,
    sendComment: sendComment,
    markMessagesRead: markMessagesRead,
    getFlowEntries: getFlowEntries,
    findOperations: findOperations,
    getMyLastOperations: getMyLastOperations,
    getMySoonEndingOperations: getMySoonEndingOperations,
    registerIncidence: registerIncidence,
    findOperationsByBook: findOperationsByBook
}

async function createGift(receiverId, message, booksIds) {
    return await httpClientWrapper.post('/api/operations/createGiftOperation', new Gift(receiverId, message, booksIds), jwtHelper.makeHttpAuthorization())
}

async function createBorrowing(message, booksIds, expirationDate) {
    return await httpClientWrapper.post('/api/operations/createBorrowingOperation', new Borrowing(message, booksIds, expirationDate), jwtHelper.makeHttpAuthorization())
}

async function createExchange(message, myBooksIds, othersBooksIds, expiration) {
    return await httpClientWrapper.post('/api/operations/createExchangeOperation', new Exchange(message, myBooksIds, othersBooksIds, expiration), jwtHelper.makeHttpAuthorization())
}

async function approve(operationId, approved) {
    return await httpClientWrapper.post('/api/operations/approve', new OperationApproval(operationId, approved), jwtHelper.makeHttpAuthorization())
}

async function confirm(operationId) {
    return await httpClientWrapper.post('/api/operations/confirm', new Operation(operationId), jwtHelper.makeHttpAuthorization())
}

async function cancel(operationId) {
    return await httpClientWrapper.post('/api/operations/cancel', new Operation(operationId), jwtHelper.makeHttpAuthorization())
}

async function confirmRetrieval(operationId) {
    return await httpClientWrapper.post('/api/operations/confirmRetrieval', new Operation(operationId), jwtHelper.makeHttpAuthorization())
}

async function findOperations(page, pageSize, filter) {
    const filterDto = (filter !== null && filter !== undefined) ? filter : new OperationFilter()
    const response = await httpClientWrapper.post(`/api/operations?page=${page}&pageSize=${pageSize}`, filterDto, jwtHelper.makeHttpAuthorization())
    decorate(response.result.collection)
    return response.result
}

async function getMyLastOperations(count) {
    const response = await httpClientWrapper.get(`/api/operations/myLastOperations?count=${count}`, jwtHelper.makeHttpAuthorization())
    const operations = response.result.collection
    decorate(operations)
    return response
}

async function getMySoonEndingOperations(count) {
    const response = await httpClientWrapper.get(`/api/operations/mySoonEndingOperations?count=${count}`, jwtHelper.makeHttpAuthorization())
    const operations = response.result.collection
    decorate(operations)
    return response
}

async function getChatThread(operationId) {
    return await httpClientWrapper.get('/api/operations/chatThread?operationId=' + operationId, jwtHelper.makeHttpAuthorization())
}

async function sendComment(commentText, operationId) {
    const comment = {
        "message": commentText,
        "operationId": operationId
    }
    return await httpClientWrapper.post('/api/operations/chatThread', comment, jwtHelper.makeHttpAuthorization())
}

async function markMessagesRead(operationId) {
    return await httpClientWrapper.post('/api/operations/chatThread/messages', { 'id': operationId }, jwtHelper.makeHttpAuthorization())
}

async function getFlowEntries(operationId) {
    return await httpClientWrapper.get('/api/operations/flow?operationId=' + operationId, jwtHelper.makeHttpAuthorization())
}

async function registerIncidence(operationId, text) {
    const incidence = {
        'operationId': operationId,
        'message': text
    }
    return await httpClientWrapper.post('/api/operations/incidence', incidence, jwtHelper.makeHttpAuthorization())
}

async function findOperationsByBook(bookId) {
    const response = await httpClientWrapper.get(`/api/operations?bookId=${bookId}`, jwtHelper.makeHttpAuthorization())
    const operations = response.result.collection
    decorate(operations)
    return response
}

function decorate(operations) {
    userService.decorate(operations.map(o => o.sender))
    userService.decorate(operations.map(o => o.receiver))
    const today = new Date()
    const sevenDaysLater = new Date(today)
    sevenDaysLater.setDate(today.getDate() + 7);
    for (const operation of operations) {
        operation.timestamp = new Date(operation.timestamp)
        if (operation.expiration !== undefined && operation.expiration !== null
            && operation.statusId < operationStatusEnum.COMPLETED) {
            operation.expiration = new Date(operation.expiration)
            if (operation.expiration <= sevenDaysLater) {
                operation['expiringSoon'] = true
            }
            const timeDifference = operation.expiration - today
            operation['daysToExpire'] = Math.ceil(timeDifference / 86400000)
        }
    }
}

export default operationService